import React, { useState, useEffect, useContext } from 'react';
import {
    Card,
    Row,
    Col,
    Badge,
    Spinner,
    Container,
    Button,
    Nav,
    Table,
    ProgressBar,
    Modal,
    Alert,
    Form
} from 'react-bootstrap';
import {
    FaArrowLeft,
    FaBook,
    FaCalendarAlt,
    FaGraduationCap,
    FaListAlt,
    FaSchool,
    FaPrint,
    FaDownload,
    FaSync,
    FaChartBar,
    FaFileAlt,
    FaTasks,
    FaClock,
    FaCheckCircle,
    FaExclamationTriangle,
    FaUserGraduate,
    FaAward,
    FaChartLine,
    FaUsers,
    FaStar,
    FaUser,
    FaIdCard,
    FaUserCheck,
    FaUserTimes,
    FaEye,
    FaRedo,
    FaFilePdf
} from 'react-icons/fa';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from './Header';
import { ProductContext } from "../context/AppContext";
import Swal from 'sweetalert2';

const ExamPapers = () => {
    const [resultData, setResultData] = useState(null);
    const [menuData, setMenuData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('Subjects');
    const [refreshing, setRefreshing] = useState(false);
    const [showChapterModal, setShowChapterModal] = useState(false);
    const [chapterData, setChapterData] = useState(null);
    const [chapterLoading, setChapterLoading] = useState(false);
    const [loadingReExam, setLoadingReExam] = useState({});
    const [alertShow, setAlertShow] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertVariant, setAlertVariant] = useState('success');
    const [copyViewAmount, setCopyViewAmount] = useState(0);
    const [selectedPaper, setSelectedPaper] = useState(null);
    const [showAnswerModal, setShowAnswerModal] = useState(false);
    const [answerModalMode, setAnswerModalMode] = useState('prompt');
    const [answerSheetImages, setAnswerSheetImages] = useState([]);
    const [answerSheetLoading, setAnswerSheetLoading] = useState(false);
    const [answerModalError, setAnswerModalError] = useState('');
    const [remarksInput, setRemarksInput] = useState('');
    const location = useLocation();
    const navigate = useNavigate();
    const { GetstudentData, Automationdata, ExamType } = useContext(ProductContext);
    const [showReExamModal, setShowReExamModal] = useState(false);
    const [reExamData, setReExamData] = useState([]);
    const [showReExamModal1, setShowReExamModal1] = useState(false);
    const [reExamData1, setReExamData1] = useState([]);
    console.log(reExamData1, "reExamData1 Data");
    

//     console.log(ExamType, "ExamType data1")

//     const refExamType = ExamType?.message?.find(
//     exam => exam?.id === leaveStudentResult?.ref_type_id
// );

    const { examType, session, className, sectionName, ApprovedExams } = location.state || {};
    const studentId = GetstudentData?.id;
    const clsSecId = GetstudentData?.cls_sec?.id;
    const sessionId = GetstudentData?.session;
    const [showExamDateModal, setShowExamDateModal] = useState(false);
    const [selectedDates, setSelectedDates] = useState([]);
    const [showSubjectModal, setShowSubjectModal] = useState(false);
    const [selectedSubjectDetails, setSelectedSubjectDetails] = useState([]);
    const [selectedSubjectName, setSelectedSubjectName] = useState("");

   

    // show_marks is independent of show_marksheet - checked per exam type
    const currentExamApproval = ApprovedExams?.find(
    item => (item?.exam_type?.id ?? item?.exam_type_id) === examType?.exam_type_id
);

const showMarks = currentExamApproval?.show_marks === true;

console.log(showMarks, "showMarks check");
    

    const openExamDateModal = (dates) => {
    setSelectedDates(dates);
    setShowExamDateModal(true);
};



// const getGroupTotals = (papers) => {
//     return papers.reduce(
//         (acc, item) => {
//             const studentResult = getStudentResult(item);

// //             if (!item?.is_display_grade) {
// //     acc.max += Number(item.max_marks || 0);
// //     acc.min += Number(item.min_marks || 0);
// //     acc.weightage += Number(item.weightage || 0);
// //     acc.obtained += Number(studentResult?.mark_obtain || 0);
// // }
// if (
//     !item?.is_display_grade &&
//     item?.attendence?.status !== "leave"
// ) {
//     acc.max += Number(item.max_marks || 0);
//     acc.min += Number(item.min_marks || 0);
//     acc.weightage += Number(item.weightage || 0);
//     acc.obtained += Number(studentResult?.mark_obtain || 0);
// }

//             return acc;
//         },
//         {
//             max: 0,
//             min: 0,
//             weightage: 0,
//             obtained: 0,
//         }
//     );
// };

// const getGroupTotals = (papers) => {
//     return papers.reduce(
//         (acc, item) => {
//             const studentResult = getStudentResult(item);

//             // Weightage hamesha add hogi
//             acc.weightage += Number(item.weightage || 0);

//             // Leave subject ke liye marks calculation skip
//             if (
//                 !item?.is_display_grade &&
//                 item?.attendence?.status !== "leave"
//             ) {
//                 acc.max += Number(item.max_marks || 0);
//                 acc.min += Number(item.min_marks || 0);
//                 acc.obtained += Number(studentResult?.mark_obtain || 0);
//             }

//             return acc;
//         },
//         {
//             max: 0,
//             min: 0,
//             weightage: 0,
//             obtained: 0,
//         }
//     );
// };

const getGroupTotals = (papers) => {
    return papers.reduce(
        (acc, item) => {
            const studentResult =
                getStudentResult(item);

            const isLeave =
                item?.attendence?.status === "leave";

            const hasReferenceMarks =
                studentResult?.ref_type_id !== null &&
                studentResult?.ref_type_id !== undefined;

            acc.weightage += Number(
                item.weightage || 0
            );

            if (
                !item?.is_display_grade &&
                (
                    !isLeave ||
                    hasReferenceMarks
                )
            ) {
                acc.max += Number(
                    item.max_marks || 0
                );

                acc.min += Number(
                    item.min_marks || 0
                );

                acc.obtained += Number(
                    studentResult?.mark_obtain || 0
                );
            }

            return acc;
        },
        {
            max: 0,
            min: 0,
            weightage: 0,
            obtained: 0,
        }
    );
};
const getGroupExamDateInfo = (papers) => {
    const dates = papers
        .map(x => x.exam_date)
        .filter(Boolean);

    const uniqueDates = [...new Set(dates)];

    const latestDate = dates.sort(
        (a, b) => new Date(b) - new Date(a)
    )[0];

    return {
        latestDate,
        hasMultipleDates:
            uniqueDates.length > 1,
        allDates: uniqueDates,
    };
};


    // console.log(examType.exam_type_id, 'examType.exam_type_id1')

    useEffect(() => {
        if (examType && studentId && clsSecId && sessionId) {
            fetchResultData();
        }
        fetchMenuData();
        fetchCopyAmount();
    }, [examType, studentId, clsSecId, sessionId]);
    const [gradingLegend, setGradingLegend] = useState([]);

    const fetchResultData = async () => {
        try {
            setLoading(true);
            const authtoken = localStorage.getItem('token');

            const response = await fetch(
                `https://api.mirai.healthcare/api/exam/result/student/bystudentid?session_id=${sessionId}&cls_sec_id=${clsSecId}&exam_type_id=${examType.exam_type_id}&student_id=${studentId}`,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-auth': authtoken
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log('API Response:', data);
            setResultData(data.message[0]);
            setGradingLegend(data?.message[0]?.GradingLegend || []);
        } catch (err) {
            console.error('Error fetching result data:', err);
        } finally {
            setLoading(false);
        }
    };

    const fetchMenuData = async () => {
        try {
            const authtoken = localStorage.getItem('token');

            const response = await fetch(
                `https://api.mirai.healthcare/api/exam/menu`,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-auth': authtoken
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setMenuData(data.message.menus);
        } catch (err) {
            console.error('Error fetching menu data:', err);
        }
    };

    const fetchCopyAmount = async () => {
        try {
            const authtoken = localStorage.getItem('token');
            const response = await fetch(
                'https://api.mirai.healthcare/api/exam/copy-view/school-info',
                {
                    method: 'GET',
                    headers: {
                        'x-auth': authtoken,
                        'Content-Type': 'application/json',
                    }
                }
            );
            const result = await response.json();
            setCopyViewAmount(result?.message?.[0]?.copy_view_amt || 0);
        } catch (error) {
            console.error('Error fetching Amount:', error);
        }
    };

    const fetchChapterData = async (paperId, studentExamResultId) => {
        try {
            setChapterLoading(true);
            const authtoken = localStorage.getItem('token');

            const response = await fetch(
                `https://api.mirai.healthcare/api/paper/chapter-mapping?student_id=${studentId}&exam_type_id=${examType.exam_type_id}&paper_id=${paperId}&cls_sec_id=${clsSecId}&student_exam_result_id=${studentExamResultId}`,
                {
                    method: 'GET',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-auth': authtoken
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            setChapterData(data.message);
        } catch (err) {
            console.error('Error fetching chapter data:', err);
            setChapterData([]);
        } finally {
            setChapterLoading(false);
        }
    };
    
    const openReExamModal = (subjectName) => {
    const reExamSubjects = (resultData?.result || [])
        .filter(
            item =>
                (item.subject_paper?.subject?.name ||
                    item.paper?.name) === subjectName
        )
        .flatMap(item =>
            (Array.isArray(item.studentResult)
                ? item.studentResult
                : [item.studentResult]
            )
                .filter(sr => sr?.reexam_date)
                .map(sr => ({
                    paperName:
                        item.paper?.name ||
                        item.subject_paper?.subject?.name,
                    reexamDate: sr.reexam_date,
                    status: sr.reexam_status,
                }))
        );

    setReExamData(reExamSubjects);
    setShowReExamModal(true);
};

const openReExamModal1 = (subjectName) => {
    

    const reExamSubjects = (resultData?.result || [])
        .filter(item =>
            (item.subject_paper?.subject?.name ||
             item.paper?.name) === subjectName
        )
        .flatMap(item =>
            (item.studentResult || [])
                .filter(sr => sr?.is_reexam)
                .map(sr => ({
                    paperName: item.paper?.name,
                    examDate: sr.exam_date,
                    reexamDate: sr.reexam_date,
                    marks: sr.mark_obtain,
                    grade: sr.grade,
                    status: sr.reexam_status || "-",
                    attendance: sr.is_present ? "Present" : "Absent",
                    is_display_grade: item.is_display_grade,
                }))
        );

    setReExamData1(reExamSubjects);
    setShowReExamModal1(true);
};

    const handleReExamApi = async (ExamResult_Id) => {
        if (!ExamResult_Id) {
            console.error('Exam Result ID is missing');
            setAlertVariant('danger');
            setAlertMessage('Exam Result ID is missing!');
            setAlertShow(true);
            return;
        }

        console.log('Clicked Re-Exam for Exam Result ID:', ExamResult_Id);
        setLoadingReExam(prev => ({ ...prev, [ExamResult_Id]: true }));

        try {
            const authtoken = localStorage.getItem('token');
            const response = await fetch(
                `https://api.mirai.healthcare/api/exam/result/reexam/${ExamResult_Id}`,
                {
                    method: 'PUT',
                    headers: {
                        'x-auth': authtoken,
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        reexam_status: 'applied',
                        applied_by: ExamResult_Id,
                        applied_at: moment().format('YYYY-MM-DD HH:mm:ss'),
                        applied_by_type: "student"
                    }),
                }
            );

            const result = await response.json();

            if (response.ok) {
                setAlertVariant('success');
                setAlertMessage(`Re-Exam applied successfully for result ID: ${ExamResult_Id}!`);
                setAlertShow(true);
                console.log('Re-Exam API Response:', result);

                // Refresh the data after successful re-exam application
                fetchResultData();
            } else {
                console.error('Failed to apply Re-Exam:', result);
                setAlertVariant('danger');
                setAlertMessage(`Failed to apply Re-Exam for result ID: ${ExamResult_Id}!`);
                setAlertShow(true);
            }
        } catch (error) {
            console.error('Error applying Re-Exam:', error);
            setAlertVariant('danger');
            setAlertMessage('Something went wrong. Please try again.');
            setAlertShow(true);
        } finally {
            setLoadingReExam(prev => ({ ...prev, [ExamResult_Id]: false }));
        }
    };

const getSubjectResultIds = (papers) => {
    return papers
        .map(item => {
            const results = Array.isArray(item.studentResult)
                ? item.studentResult
                : [item.studentResult];

            const lastResult = results?.[results?.length - 1];

            return lastResult?.id;
        })
        .filter(Boolean);
};



    const handleReExamConfirm = (ExamResult_Id, subjectName) => {
        Swal.fire({
            title: 'Apply for Re-Exam?',
            text: `Are you sure you want to apply for re-exam for ${subjectName}?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, Apply!',
            cancelButtonText: 'Cancel'
        }).then((result) => {
            if (result.isConfirmed) {
                handleReExamApi(ExamResult_Id);
            }
        });
    };

    const handleBulkReExamApi = async (examResultIds) => {
    try {
        const authtoken = localStorage.getItem("token");

        await Promise.all(
            examResultIds.map((id) =>
                fetch(
                    `https://api.mirai.healthcare/api/exam/result/reexam/${id}`,
                    {
                        method: "PUT",
                        headers: {
                            "x-auth": authtoken,
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify({
                            reexam_status: "applied",
                            applied_by: id,
                            applied_at: moment().format('YYYY-MM-DD'),
                            applied_by_type: "student"
                        }),
                    }
                )
            )
        );

        fetchResultData();

        Swal.fire(
            "Success",
            "Re-Exam applied for all papers.",
            "success"
        );
    } catch (error) {
        console.error(error);

        Swal.fire(
            "Error",
            "Failed to apply Re-Exam",
            "error"
        );
    }
};

// const getGradeFromMarks = (marks, maxMarks) => {
//     const percentage = (Number(marks || 0) / Number(maxMarks || 1)) * 100;

//     if (percentage >= 91) return "A1";
//     if (percentage >= 81) return "A2";
//     if (percentage >= 71) return "B1";
//     if (percentage >= 61) return "B2";
//     if (percentage >= 51) return "C1";
//     if (percentage >= 41) return "C2";
//     if (percentage >= 33) return "D";
//     return "E";
// };

console.log(gradingLegend, "gradingLegend Data");

const getGradeFromMarks = (marks, maxMarks) => {
    if (
        marks === null ||
        marks === undefined ||
        !maxMarks
    ) {
        return "-";
    }

    const percentage =
        (Number(marks) / Number(maxMarks)) * 100;

    const gradeObj = gradingLegend.find(
        item =>
            percentage >= Number(item.min_percentage) &&
            percentage <= Number(item.max_percentage)
    );

    return gradeObj?.grade || "-";
};
const handleBulkReExamConfirm = (
    subjectName,
    papers
) => {
    const resultIds =
        getSubjectResultIds(papers);

    Swal.fire({
        title: "Apply Re-Exam?",
        text: `Apply Re-Exam for all papers of ${subjectName}?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, Apply",
    }).then((result) => {
        if (result.isConfirmed) {
            handleBulkReExamApi(resultIds);
        }
    });
};

const handleViewSubjectDetails = (
    subjectName,
    papers
) => {
    setSelectedSubjectName(subjectName);
    setSelectedSubjectDetails(papers);
    setShowSubjectModal(true);
};


    const handleViewChapterReport = async (paperId, studentExamResultId) => {
        await fetchChapterData(paperId, studentExamResultId);
        setShowChapterModal(true);
    };

    const handleCloseChapterModal = () => {
        setShowChapterModal(false);
        setChapterData(null);
    };

    const resetAnswerModalState = () => {
        setAnswerSheetImages([]);
        setAnswerModalError('');
        setAnswerSheetLoading(false);
        setRemarksInput('');
    };

    const handleCloseAnswerModal = () => {
        resetAnswerModalState();
        setShowAnswerModal(false);
        setSelectedPaper(null);
    };

    const getSubjectPaperIds = (papers) => {
    return papers
        .filter(Boolean)
        .map(item => item.paper_id);
};

    const handleViewAnswerSheet = async (
    paperId,
    studentExamResultId,
    subjectName,
    hasCopyRequest,
    papers
) => {

    // const paperIds = getSubjectPaperIds(subjectName);

console.log("subjectName:", subjectName);
const paperIds = getSubjectPaperIds(papers);

// console.log("paperIds", paperIds); // [11,12]
// console.log("paperIds:", paperIds);




    setSelectedPaper({
        paperId,
        paperIds, // 👈 all paper ids
        studentExamResultId,
        subjectName,
        hasCopyRequest,
    });

    setShowAnswerModal(true);
    resetAnswerModalState();

    if (hasCopyRequest) {
        setAnswerModalMode("viewer");
        await handleCheckAnswerSheet(paperIds);
    } else {
        setAnswerModalMode("prompt");
    }
};

    

    const handleCopyCheckPayNow = async (paperIds, studentExamResultId, remarks) => {
        const trimmedRemarks = remarks?.trim();
        // if (!trimmedRemarks) {
        //     setAnswerModalError('Remarks are required to proceed.');
        //     return;
        // }

        try {
            setAnswerSheetLoading(true);
            setAnswerModalError('');
            const authtoken = localStorage.getItem('token');

            const payload = {
                student_id: studentId,
                exam_type_id: examType.exam_type_id,
                paper_id: paperIds,
                reason: trimmedRemarks,
                status: 'pending',
                student_exam_result_id: studentExamResultId,
                cls_sec_id: clsSecId,
            };

            console.log('Submitting Copy View Request:', payload);

            const response = await fetch('https://api.mirai.healthcare/api/exam/copy-view', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-auth': authtoken,
                },
                body: JSON.stringify(payload),
            });

            const json = await response.json();

            if (response.ok && json.success) {
                const copyCheckId = json?.message?.StudentCopyCheckRequest?.id;
                const copyCheckIds = json?.message?.StudentCopyCheckRequest?.map(item => item?.id) || [];

console.log(copyCheckIds, "copyCheckIds Data"); // [97, 98]

await handlePayNow(copyCheckIds);
                console.log("Copy Check ID from API:", copyCheckId);
                // await handlePayNow(copyCheckId);
            } else {
                setAnswerModalError(json.message || 'Failed to create copy view request.');
            }
        } catch (error) {
            console.error('Copy View API Error:', error);
            setAnswerModalError('Failed to submit copy view request. Please try again.');
        } finally {
            setAnswerSheetLoading(false);
        }
    };

    const handlePayNow = async (copyCheckIds) => {
        console.log("Selected copyCheckId:", copyCheckIds);
        const authtoken = localStorage.getItem('token');

        // Get student details (you might need to fetch these from context or API)
        const studentFullName = GetstudentData?.student_full_name || '';
        const studentEmail = GetstudentData?.father_email || GetstudentData?.mother_email || '';
        const studentMobileNo = GetstudentData?.father_mobile_no || GetstudentData?.mother_mobile_no || '';

        const paymentDetails = {
            amount: copyViewAmount,
            productinfo: 'Copy Review Fee',
            firstname: studentFullName,
            email: studentEmail,
            phone: studentMobileNo,
            copyCheckId: copyCheckIds,
            paymentMethod: Automationdata?.data?.[0]?.PaymentMethod,
        };

        const query = new URLSearchParams({
            ...paymentDetails,
              copyCheckId: paymentDetails.copyCheckId?.join(","),
            authToken: authtoken || '',
        }).toString();

        console.log(paymentDetails, "paymentDetails");

        const url = `${window.location.origin}/pay-u-payment?${query}`;
        window.open(url, '_blank');
        console.log(url, "url Final");

        handleCloseAnswerModal();
        setAlertVariant('info');
        setAlertMessage('Payment window opened. Complete the payment to unlock the answer sheet.');
        setAlertShow(true);
    };

    const handleCheckAnswerSheet = async (paperIds) => {
    try {
        setAnswerSheetLoading(true);
        setAnswerModalError("");

        const authtoken = localStorage.getItem("token");

        const responses = await Promise.all(
            paperIds.map(async (paperId) => {
                const url = `https://api.mirai.healthcare/api/exam/copy-view?student_id=${studentId}&exam_id=${examType.exam_type_id}&paper_id=${paperId}&payment_status=paid`;

                const response = await fetch(url, {
                    method: "GET",
                    headers: {
                        "x-auth": authtoken,
                        "Content-Type": "application/json",
                    },
                });

                return response.json();
            })
        );

        const allAttachments = responses.flatMap(
            (res) =>
                res?.message?.flatMap(
                    (item) => item?.attch || []
                ) || []
        );

        console.log("All Answer Sheets:", allAttachments);

        if (allAttachments.length > 0) {
            setAnswerSheetImages(allAttachments);
        } else {
            setAnswerSheetImages([]);
            setAnswerModalError(
                "No answer sheet available for this subject."
            );
        }
    } catch (error) {
        console.error(error);
        setAnswerModalError(
            "Failed to fetch answer sheet."
        );
    } finally {
        setAnswerSheetLoading(false);
    }
};

    const handleBack = () => {
        navigate(-1);
    };

    const handleRefresh = () => {
        setRefreshing(true);
        fetchResultData();
        setTimeout(() => setRefreshing(false), 1000);
    };

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        return moment(dateString).format('DD MMMM YYYY');
    };
    const getStudentResult = (item) => {
    if (!item.studentResult) return null;

    if (Array.isArray(item.studentResult)) {
        return item.studentResult[item?.studentResult?.length - 1] || null;
    }

    return item.studentResult;
};
    
const calculateOverallPercentage = () => {
    if (!resultData?.result) return 0;

    let totalMarks = 0;
    let totalMaxMarks = 0;

    console.log("Total Obtained:", totalMarks);
console.log("Total Max:", totalMaxMarks);
console.log(
  "Overall %",
  ((totalMarks / totalMaxMarks) * 100).toFixed(2)
);


    resultData.result.forEach(item => {
        if (item?.is_display_grade) return;

        const studentResult = getStudentResult(item);

        totalMarks += Number(studentResult?.mark_obtain || 0);
        totalMaxMarks += Number(item?.max_marks || 0);
    });

    return totalMaxMarks > 0
        ? (totalMarks / totalMaxMarks) * 100
        : 0;
};

    const getGradeColor = (grade) => {
        if (!grade) return 'secondary';
        const gradeColors = {
            'A+': 'success',
            'A': 'success',
            'B+': 'info',
            'B': 'info',
            'C+': 'warning',
            'C': 'warning',
            'D': 'danger',
            'F': 'danger'
        };
        return gradeColors[grade] || 'secondary';
    };

    const getAttendanceBadge = (item) => {
    const attendance = item?.attendence;

    if (attendance?.status === "present") {
        return (
            <Badge bg="success" className="attendance-badge">
                <FaUserCheck className="me-1" size={10} />
                Present
            </Badge>
        );
    }

    if (attendance?.status === "absent") {
        return (
            <Badge bg="danger" className="attendance-badge">
                <FaUserTimes className="me-1" size={10} />
                Absent
            </Badge>
        );
    }

    if (attendance?.status === "leave") {
        return (
            <Badge bg="warning" className="attendance-badge">
                {attendance?.leave_type?.toLowerCase() === "medical"
                    ? "ML"
                    : attendance?.leave_type?.toLowerCase() === "casual"
                    ? "CL"
                    : "Leave"}
            </Badge>
        );
    }

    return (
        <Badge bg="secondary" className="attendance-badge">
            <FaUser className="me-1" size={10} />
            Not Marked
        </Badge>
    );
};

    const renderChapterModal = () => (
        <Modal show={showChapterModal} onHide={handleCloseChapterModal} size="lg" centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FaBook className="me-2 text-primary" />
                    Chapter Report
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {chapterLoading ? (
                    <div className="text-center py-4">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-2 text-muted">Loading chapter data...</p>
                    </div>
                ) : chapterData && chapterData.length > 0 ? (
                    <div className="table-responsive">
                        <Table className="mb-0 chapter-table">
                            <thead className="table-light">
                                <tr>
                                    <th>Chapter Name</th>
                                    <th>Description</th>
                                    <th>Complete Date</th>
                                    <th>Deadline</th>
                                    <th>Max Marks</th>
                                    <th>Min Marks</th>
                                </tr>
                            </thead>
                            <tbody>
                                {chapterData.map((item, index) => (
                                    <tr key={item.id} className="chapter-row">
                                        <td>
                                            <strong className="text-dark">{item.chapter?.name || 'N/A'}</strong>
                                        </td>
                                        <td>
                                            <small className="text-muted">{item.chapter?.description || 'No description'}</small>
                                        </td>
                                        <td>
                                            <div className="text-dark small">{formatDate(item.chapter?.complete_date)}</div>
                                        </td>
                                        <td>
                                            <div className="text-dark small">{formatDate(item.chapter?.deadline_date)}</div>
                                        </td>
                                        <td>
                                            <Badge bg="outline-primary" className="border marks-badge">
                                                {item.chapter_result?.max_marks || 'N/A'}
                                            </Badge>
                                        </td>
                                        <td>
                                            <Badge bg="outline-secondary" className="border marks-badge">
                                                {item.chapter_result?.min_marks || 'N/A'}
                                            </Badge>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                ) : (
                    <div className="text-center py-4 empty-state">
                        <FaBook size={48} className="text-muted mb-3 opacity-50" />
                        <h5 className="text-dark mb-2">No Chapter Data</h5>
                        <p className="text-muted">No chapter report data available for this subject.</p>
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseChapterModal}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    );

    const renderAnswerSheetModal = () => (
        <Modal
            show={showAnswerModal}
            onHide={handleCloseAnswerModal}
            size="lg"
            centered
            scrollable
        >
            <Modal.Header closeButton>
                <Modal.Title className="d-flex align-items-center gap-2">
                    <FaFilePdf className="text-danger" />
                    View Answer Sheet
                    
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {answerModalMode === 'prompt' ? (
                    <div>
                        <p className="text-muted mb-3">
                            View detailed answer copies for <strong>{selectedPaper?.subjectName}</strong> by completing a quick request.
                        </p>
                        <div className="d-flex flex-column flex-md-row gap-3 mb-3">
                            <Card className="flex-fill border-0 shadow-sm">
                                <Card.Body className="py-3">
                                    <div className="text-muted small">Fee</div>
                                    <div className="fs-4 fw-bold text-dark">₹{copyViewAmount}</div>
                                </Card.Body>
                            </Card>
                            <Card className="flex-fill border-0 shadow-sm">
                                <Card.Body className="py-3">
                                    <div className="text-muted small">Status</div>
                                    <div className="fs-4 fw-bold text-dark">Payment Required</div>
                                </Card.Body>
                            </Card>
                        </div>
                        <Form.Group controlId="copyRemarks">
                            <Form.Label className="fw-semibold">Remarks</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                placeholder="Enter remarks for school (required)"
                                value={remarksInput}
                                onChange={(e) => setRemarksInput(e.target.value)}
                            />
                        </Form.Group>
                        {answerModalError && (
                            <Alert variant="danger" className="mt-3 mb-0">
                                {answerModalError}
                            </Alert>
                        )}
                    </div>
                ) : (
                    <div>
                        {answerSheetLoading ? (
                            <div className="text-center py-4">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-3 mb-0 text-muted">Fetching answer sheet...</p>
                            </div>
                        ) : answerSheetImages?.length > 0 ? (
                            <Row className="g-3 answer-sheet-gallery">
                                <div className="d-flex justify-content-end">
                    
                    </div>
                    

{answerSheetImages?.map((imageData, index) => {
    const fileUrl = imageData?.file_url;
    // const isPdf = /\.(pdf)$/i.test(fileUrl);
    const isPdf =
  imageData?.file_type === "application/pdf" ||
  fileUrl?.toLowerCase().includes(".pdf");

    return (
        <Col md={4} key={index}>
            <Card className="answer-sheet-card">
                <div className="answer-sheet-frame">
                    

                    {isPdf ? (
    <div
        className="text-center border rounded p-4"
        style={{
            cursor: "pointer",
            minHeight: "250px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center"
        }}
        onClick={() => window.open(fileUrl, "_blank")}
    >
        <FaFilePdf size={70} className="text-danger mb-2" />
        <div className="fw-semibold">Open PDF</div>
    </div>
) : (
    <img
        src={fileUrl}
        alt={`Answer Sheet ${index + 1}`}
        className="img-fluid"
        style={{
            cursor: "pointer",
            width: "100%",
            height: "250px",
            objectFit: "contain"
        }}
        onClick={() => window.open(fileUrl, "_blank")}
    />
)}

                </div>

                <Card.Body className="py-2">
                    <div className="text-muted small text-center">
                        {imageData.file_name || `Page ${index + 1}`}
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
})}

                                
                            </Row>
                        ) : (
                            <div className="text-center py-5">
                                <FaFilePdf size={48} className="text-muted mb-3 opacity-50" />
                                <h5 className="text-dark mb-2">No Answer Sheet Found</h5>
                                <p className="text-muted mb-0">Once the school uploads the answer copy, it will appear here.</p>
                            </div>
                        )}
                        {answerModalError && (
                            <Alert variant="info" className="mt-3 mb-0">
                                {answerModalError}
                            </Alert>
                        )}
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer className="flex-wrap gap-2">
                <Button variant="secondary" onClick={handleCloseAnswerModal}>
                    Close
                </Button>
                {answerModalMode === 'prompt' ? (
                    <Button
                        variant="primary"
                        
                            onClick={() =>
        handleCopyCheckPayNow(
            selectedPaper?.paperIds,
            selectedPaper?.studentExamResultId,
            remarksInput
        )
    }
                        disabled={
                            answerSheetLoading ||
                            !selectedPaper?.paperId ||
                            !selectedPaper?.studentExamResultId
                        }
                    >
                        {answerSheetLoading ? (
                            <Spinner animation="border" size="sm" className="me-2" />
                        ) : (
                            <FaFilePdf className="me-2" size={14} />
                        )}
                        Pay ₹{copyViewAmount}
                    </Button>
                ) : (
                    <>
                    <Button
                        variant="primary"
                        onClick={() => handleCheckAnswerSheet(selectedPaper?.paperIds)}
                        disabled={answerSheetLoading || !selectedPaper?.paperId}
                    >
                        {answerSheetLoading ? (
                            <Spinner animation="border" size="sm" className="me-2" />
                        ) : (
                            <FaSync className="me-2" />
                        )}
                        Refresh
                    </Button>

                    
                    
                    </>
                )}
            </Modal.Footer>
        </Modal>
    );

    const StatCard = ({ icon: Icon, title, value, subtitle, color = 'primary' }) => (
        <Card className="stat-card border-0 h-100 shadow-sm">
            <Card.Body className="p-3">
                <div className="d-flex align-items-center">
                    <div className={`icon-container bg-${color} me-3 flex-shrink-0`}>
                        <Icon size={18} className="text-white" />
                    </div>
                    <div className="flex-grow-1">
                        <h6 className="text-muted mb-1 small">{title}</h6>
                        <h4 className="fw-bold text-dark mb-0">{value}</h4>
                        {subtitle && <small className="text-muted">{subtitle}</small>}
                    </div>
                </div>
            </Card.Body>
        </Card>
    );

    const renderSubjectsTab = () => {
    const subjects = resultData?.result || [];

    // 👇 Yahan add karo
    const groupedSubjects = subjects.reduce((acc, item) => {
        const subjectName =
            item.subject_paper?.subject?.name ||
            item.paper?.name;

        if (!acc[subjectName]) {
            acc[subjectName] = [];
        }

        acc[subjectName].push(item);

        return acc;
    }, {});


        const buildSubjectMeta = (item) => {
            const studentResult = getStudentResult(item);
            const marksObtained = parseFloat(studentResult?.mark_obtain) || 0;
            const percentage = item.max_marks > 0 ? (marksObtained / item.max_marks) * 100 : 0;
            const isPresent = studentResult?.is_present;

            const attendance = item?.attendence;
            const attendanceStatus = attendance?.status;
            const leaveType = attendance?.leave_type;


            const isPass = marksObtained >= item?.min_marks;
            const studentExamResultId = studentResult?.id;
            const subjectName = item.paper?.name || 'Unknown Subject';
            // const LastStudentResult = studentResult?.at(-1);
            const hasCopyRequest = !!studentResult?.copy_request;
            
            // const canApplyReExam = item?.exam?.apply_reexam === true;
            const canViewAnswerSheet = item?.exam?.recheck_copy === true;
            const noStudentResult = !studentResult;

            

    const canApplyReExam = item?.exam?.apply_reexam === true;

// const isFailed =
//     marksObtained < Number(item?.min_marks || 0);

const isAlreadyApplied =
    studentResult?.reexam_status === "applied";
const showReExamButton =
    canApplyReExam &&
    Boolean(studentResult) &&
    !isAlreadyApplied;

    const subjects = resultData?.result || [];

const groupedSubjects = subjects.reduce((acc, item) => {
    const subjectName =
        item.subject_paper?.subject?.name ||
        item.paper?.name;

    if (!acc[subjectName]) {
        acc[subjectName] = [];
    }

    acc[subjectName].push(item);

    return acc;
}, {});

            return {
                studentResult,
                marksObtained,
                percentage,
                isPresent,
                isPass,
                studentExamResultId,
                subjectName,
                hasCopyRequest,
                showReExamButton,
                isAlreadyApplied,
                noStudentResult,
                canViewAnswerSheet
            };
        };

        const renderActionButtons = (item, ctx, papers, subjectName, groupCanApplyReExam, groupAlreadyApplied) => (
            <>
            
    <>
    {showMarks ===true && (
        <Button
            variant="outline-info"
            size="sm"
            className="view-chapter-btn"
            onClick={() =>
                handleViewChapterReport(
                    item.paper_id,
                    ctx.studentExamResultId
                )
            }
            disabled={!ctx.studentExamResultId}
            title="View Chapter Report"
        >
            <FaEye className="me-1" size={12} />
            Chapter Report
        </Button>
    )}

        {/* ✅ Show only when recheck_copy = true */}
        {ctx.canViewAnswerSheet && (
            <Button
                variant="outline-success"
                size="sm"
                className="view-answer-btn"
                onClick={() =>
    handleViewAnswerSheet(
        item?.paper_id,
        ctx?.studentExamResultId,
        ctx?.subjectName,
        ctx?.hasCopyRequest,
        papers
    )
}
                disabled={!ctx.studentExamResultId}
                title={
                    ctx.hasCopyRequest
                        ? "View Answer Sheet" : "Apply Answer Sheet"
                }
            >
                <FaFilePdf className="me-1" size={12} />
                {ctx.hasCopyRequest
                    ? "View Answer Sheet" : "Apply Answer Sheet"}
            </Button>
        )}



        {groupCanApplyReExam &&
    !groupAlreadyApplied && (
        <Button
            variant="outline-warning"
            size="sm"
            className="reexam-btn"
            onClick={() =>
                handleBulkReExamConfirm(
                    subjectName,
                    papers
                )
            }
        >
            <FaRedo className="me-1" size={12} />
            Apply Re-Exam
        </Button>
 )}

        {ctx.isAlreadyApplied && (
            <Badge
                bg="info"
                className="already-applied-badge"
            >
                <FaCheckCircle className="me-1" size={10} />
                Already Applied
            </Badge>
        )}

    </>
            </>
        );

        return (
            <Card className="modern-card border-0 shadow-sm">
                <Card.Header className="modern-card-header d-flex flex-column flex-md-row align-items-md-center justify-content-md-between gap-3">
                    <div className="d-flex align-items-center gap-2">
                        <FaBook className="text-primary" />
                        <div>
                            <h5 className="mb-0">Subject Results</h5>
                            <small className="text-muted">Detailed marks, attendance and actions</small>
                        </div>
                    </div>
                    <Badge bg="light" className="fw-semibold text-dark">
                        {Object.keys(groupedSubjects)?.length} Subjects
                    </Badge>
                </Card.Header>
                <Card.Body className="p-0">
                    {subjects?.length > 0 ? (
                        <>
                            <div className="table-responsive d-none d-md-block">
                                <Table className="mb-0 results-table align-middle">
                                    <thead className="table-light">
                                        <tr>
                                            <th className="ps-4">Subject Name</th>
                                            <th>Exam Date</th>
                                            <th>Time</th>
                                            <th>Max Marks</th>
                                            <th>Min Marks</th>
                                            <th>Weightage</th>
                                            {showMarks ===true && (
                                                <>
                                                
                                            <th>Marks Obtained</th>
                                            <th>Re-Exam Marks</th>
                                            <th>Grade</th>
                                            <th>Percentage</th>
                                            </>
                                              )}
                                            <th>Attendance</th>
                                            
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
    {Object.entries(groupedSubjects).map(
        ([subjectName, papers]) => {
            const firstPaper = papers[0];

            const ctx =
                buildSubjectMeta(firstPaper);

                const totals = getGroupTotals(papers);

const groupCanApplyReExam =
    papers.some(
        paper => paper?.exam?.apply_reexam === true
    ) &&
    totals.obtained < totals.min;

const groupAlreadyApplied = papers.some(item => {
    const sr = getStudentResult(item);

    return sr?.reexam_status === "applied";
});

const groupInfo = getGroupExamDateInfo(papers);

const isLeaveSubject = papers.every(
    p => p?.attendence?.status === "leave"
);

const leavePaper = papers.find(
    p => p?.attendence?.status === "leave"
);

const leaveStudentResult = leavePaper
    ? getStudentResult(leavePaper)
    : null;

const hasReferenceMarks =
    leaveStudentResult?.ref_type_id !== null &&
    leaveStudentResult?.ref_type_id !== undefined;


            const percentage =
                totals.max > 0
                    ? (
                          (totals.obtained /
                              totals.max) *
                          100
                      ).toFixed(1)
                    : 0;

                    const hasReExam = papers?.some(item =>
  (Array?.isArray(item?.studentResult)
    ? item?.studentResult
    : [item?.studentResult]
  ).some(sr => sr?.is_reexam)
);

            return (
                <tr
                    key={subjectName}
                    className="result-row"
                >
                    {/* Subject */}
                    <td className="ps-4">
    <div className="d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
            <div
                className="subject-icon bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
                style={{
                    width: "42px",
                    height: "42px",
                }}
            >
                <FaBook size={16} />
            </div>

            <div>
                <h6 className="fw-bold mb-0">
                    {subjectName}
                    {leaveStudentResult?.ref_type_id && (
                    <sup>
                        <Badge bg="outline-danger">
                        
                        Ref : {
        ExamType?.message?.find(
            exam => exam.id === leaveStudentResult?.ref_type_id
        )?.name
    }
    </Badge>
    </sup>
    )}
                </h6>

                <small className="text-muted">
                    {papers.length} Paper
                    {papers.length > 1 ? "s" : ""}
                </small>
                <small className="text-muted">
                    {showMarks ===true && (
        <Button
            variant="light"
            size="sm"
            className="border shadow-sm rounded-pill"
            onClick={() =>
                handleViewSubjectDetails(
                    subjectName,
                    papers
                )
            }
        >
            <FaEye className="me-1 text-primary" />
            Details
        </Button>
)}
                </small>
            </div>
        </div>

    </div>
</td>
                    {/* Exam Date */}
                    <td>
    <div className="d-flex flex-column">
        <span className="fw-semibold">
            {formatDate(groupInfo.latestDate)}
        </span>

        {papers.some(item =>
            (Array.isArray(item.studentResult)
                ? item.studentResult
                : [item.studentResult]
            ).some(sr => sr?.reexam_date)
        ) && (
            <Button
                variant="link"
                className="p-0 mt-1 text-decoration-none fw-semibold"
                onClick={() => openReExamModal(subjectName)}
            >
                <FaCalendarAlt className="me-1" />
                Re-Exam Dates
            </Button>
        )}

 </div>
</td>

                    {/* Time */}
                    <td>
                        {
                            firstPaper.start_time
                        }{" "}
                        -{" "}
                        {
                            firstPaper.end_time
                        }
                    </td>
<td>
    {papers.every(p => p?.is_display_grade) || (isLeaveSubject && !hasReferenceMarks) ? (
        
        "-"
    ) : (
        <Badge bg="outline-primary">
            {totals.max}
        </Badge>
    )}
</td>

                    {/* Min Marks */}
                    <td>
    {papers.every(p => p?.is_display_grade) || (isLeaveSubject && !hasReferenceMarks) ? (
        "-"
    ) : (
        <Badge bg="outline-secondary">
            {totals.min}
        </Badge>
    )}
</td>

                    {/* Weightage */}
                    <td>
    {papers.every(p => p?.is_display_grade) ? (
        "-"
    ) : (
        
        <Badge bg="outline-success">
            {totals.weightage}
        </Badge>
    )}
</td>

                    {showMarks ===true && (
                        <>
                            {/* Marks Obtained */}
                            <td>
    {papers.every(p => p?.is_display_grade) || (isLeaveSubject && !hasReferenceMarks) ? (
        "-"
    ) : (
        <Badge
            bg={
                totals.obtained >= totals.min
                    ? "success"
                    : "danger"
            }
        >
            {totals.obtained}
        </Badge>
    )}
</td>

                            

                            
{hasReExam ?  (
<td>
    <Button
        variant="outline-primary"
        size="sm"
        onClick={() => openReExamModal1(subjectName)}
    >
        <FaRedo className="me-1" />
        Re-Exam Marks
    </Button>
</td>
) : (
    <p className='text-center'>--</p>
)}

{/* Grade */}
                            <td>
    {firstPaper?.is_display_grade || isLeaveSubject
        ? getGradeFromMarks(
              ctx?.studentResult?.mark_obtain,
              firstPaper?.max_marks
          )
        : (
            ctx?.studentResult?.grade ||
            getGradeFromMarks(
                ctx?.studentResult?.mark_obtain,
                firstPaper?.max_marks
            )
          )}
</td>

                            {/* Percentage */}
                            <td>
    {papers.every(p => p?.is_display_grade) || (isLeaveSubject && !hasReferenceMarks) ? (
        "-"
    ) : (
        <div>{percentage}%</div>
    )}
</td>
                        </>
                    )}

                    {/* Attendance */}
                    <td>
                        {getAttendanceBadge(firstPaper)}
                    </td>

                    
                    <td>
                                <div className="d-flex flex-column gap-2">
                                    {renderActionButtons(
                                        firstPaper,
                                        ctx,
                                        papers,
                                        subjectName,
                                        groupCanApplyReExam,
                                        groupAlreadyApplied
                                    )}
                                </div>
                            </td>
                </tr>
            );
        }
    )}
</tbody>
                                    
                                </Table>
                            </div>
                            <Modal
    show={showSubjectModal}
    onHide={() => setShowSubjectModal(false)}
    size="lg"
    centered
>
    <Modal.Header closeButton>
        <Modal.Title>
            {selectedSubjectName} Details
        </Modal.Title>
    </Modal.Header>

    <Modal.Body>
        <Table bordered hover responsive>
            <thead>
                <tr>
                    <th>Paper</th>
                    <th>Obtained</th>
                    <th>Grade</th>
                    <th>Percentage</th>
                    <th>Min Marks</th>
                    <th>Max Marks</th>
                    <th>Weightage</th>
                </tr>
            </thead>

            <tbody>
                {selectedSubjectDetails.map(
                    (item, index) => {
                        const studentResult =
                            getStudentResult(item);

                        const obtained =
                            Number(
                                studentResult?.mark_obtain || 0
                            );

                        const percentage =
                            item.max_marks > 0
                                ? (
                                      (obtained /
                                          item.max_marks) *
                                      100
                                  ).toFixed(1)
                                : 0;

                                const isLeaveSubject =
        item?.attendence?.status === "leave";

    const hasReferenceMarks =
    studentResult?.ref_type_id !== null &&
    studentResult?.ref_type_id !== undefined;

                        return (
                            <tr key={index}>
    <td>
        {item.paper?.name}
        <sup>
             {studentResult?.ref_type_id && (
        <div className="mt-1">
            <Badge bg="warning">
                Ref :
                {
                    ExamType?.message?.find(
                        exam =>
                            exam.id ===
                            studentResult?.ref_type_id
                    )?.name
                }
            </Badge>
        </div>
    )}
        </sup>
    </td>
    <td>
        {item?.is_display_grade || (isLeaveSubject && !hasReferenceMarks) ? "-" : obtained}
    </td>
    <td>
    {(isLeaveSubject && !hasReferenceMarks)
        ? "-"
        : item?.is_display_grade
        ? getGradeFromMarks(
              studentResult?.mark_obtain,
              item?.max_marks
          )
        : (
              studentResult?.grade ||
              getGradeFromMarks(
                  studentResult?.mark_obtain,
                  item?.max_marks
              )
          )}
</td>
<td>
        {item?.is_display_grade || (isLeaveSubject && !hasReferenceMarks)
            ? "-"
            : `${percentage}%`
        }
    </td>

    <td>
        {item?.is_display_grade || (isLeaveSubject && !hasReferenceMarks) ? "-" : item.min_marks}
    </td>

    <td>
        {item?.is_display_grade || (isLeaveSubject && !hasReferenceMarks) ? "-" : item.max_marks}
    </td>

    
    <td>
        {item?.is_display_grade ? "-" : item.weightage}
    </td>

    

    

    {/* <td>
    {item?.is_display_grade || isLeaveSubject
        ? getGradeFromMarks(
              studentResult?.mark_obtain,
              item?.max_marks
          )
        : (studentResult?.grade || "-")
    }
</td> */}
</tr>
                        );
                    }
                )}
            </tbody>
        </Table>
    </Modal.Body>
</Modal>
                            <Modal
    show={showReExamModal}
    onHide={() => setShowReExamModal(false)}
    centered
>
    <Modal.Header closeButton>
        <Modal.Title>
            Re-Exam Schedule
        </Modal.Title>
    </Modal.Header>

    <Modal.Body>
        {reExamData.length > 0 ? (
            <Table bordered hover>
                <thead>
                    <tr>
                        <th>Paper Name</th>
                        <th>Re-Exam Date</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {reExamData.map((item, index) => (
                        <tr key={index}>
                            <td>{item.paperName}</td>
                            <td>{item.reexamDate}</td>
                            <td>
                                <Badge bg="success">
                                    {item.status}
                                </Badge>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        ) : (
            <p className="text-center mb-0">
                No Re-Exam Date Available
            </p>
        )}
    </Modal.Body>

    <Modal.Footer>
        <Button
            variant="secondary"
            onClick={() => setShowReExamModal(false)}
        >
            Close
        </Button>
    </Modal.Footer>
</Modal>

<Modal
    show={showReExamModal1}
    onHide={() => setShowReExamModal1(false)}
    size="xl"
    centered
>
    <Modal.Header closeButton>
        <Modal.Title>Re-Exam Details</Modal.Title>
    </Modal.Header>

    <Modal.Body>

        {reExamData1.length > 0 ? (

            <Table bordered hover responsive>
                <thead className="table-light">
                    <tr>
                        <th>Attempt</th>
                        <th>Paper</th>
                        {/* <th>Marks</th>
                        <th>Grade</th> */}
                                <th>{reExamData1[0]?.is_display_grade ? "Grade" : "Marks"}</th>
                        <th>Exam Date</th>
                        {/* <th>Re-Exam Date</th> */}
                        <th>Attendance</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>

                    {reExamData1.map((item,index)=>(
                        <tr key={index}>
                            <td>
                <Badge bg={index === 0 ? "secondary" : "warning"}>
                    {index === 0 ? "Main" : `Re${index}`}
                </Badge>
            </td>
                            <td>{item.paperName}</td>
                            {/* <td>{item.marks}</td>
                            <td>{item.grade}</td> */}
                            <td>
  {item.is_display_grade
    ? item.grade || "-"
    : item.marks || "-"}
</td>
                            <td>{item.examDate}</td>
                            {/* <td>{item.reexamDate || "-"}</td> */}
                            <td>{item.attendance}</td>
                            <td>
                                <Badge bg={
                                    item.status==="approved"
                                    ? "success"
                                    : item.status==="pending"
                                    ? "warning"
                                    : "secondary"
                                }>
                                    {item.status}
                                </Badge>
                            </td>
                        </tr>
                    ))}

                </tbody>
            </Table>

        ) : (

            <div className="text-center py-3">
                No Re-Exam Data Available
            </div>

        )}

    </Modal.Body>

    <Modal.Footer>
        <Button
            variant="secondary"
            onClick={() => setShowReExamModal(false)}
        >
            Close
        </Button>
    </Modal.Footer>

</Modal>

                            

                            <div className="d-md-none p-3 subject-mobile-list">
    {Object.entries(groupedSubjects).map(
        ([subjectName, papers]) => {

            const firstPaper = papers[0];
            const ctx = buildSubjectMeta(firstPaper);

            const totals = getGroupTotals(papers);

            const gradePaper = papers.find(
    paper => paper?.is_display_grade === true
);

const gradeStudentResult = gradePaper
    ? getStudentResult(gradePaper)
    : null;

// const displayGrade = gradePaper
//     ? getGradeFromMarks(
//           gradeStudentResult?.mark_obtain,
//           gradePaper?.max_marks
//       )
//     : (
//           ctx?.studentResult?.grade ||
//           getGradeFromMarks(
//               ctx?.studentResult?.mark_obtain,
//               firstPaper?.max_marks
//           )
//       );


        const displayGrade =
    firstPaper?.is_display_grade
        ? getGradeFromMarks(
              ctx?.studentResult?.mark_obtain,
              firstPaper?.max_marks
          )
        : (
              ctx?.studentResult?.grade ||
              getGradeFromMarks(
                  ctx?.studentResult?.mark_obtain,
                  firstPaper?.max_marks
              )
          );

        const percentage =
    totals.max > 0
        ? ((totals.obtained / totals.max) * 100).toFixed(1)
        : 0;

const isLeaveSubject = papers.every(
    p => p?.attendence?.status === "leave"
);
const leavePaper = papers.find(
    p => p?.attendence?.status === "leave"
);

const leaveStudentResult = leavePaper
    ? getStudentResult(leavePaper)
    : null;

const hasReferenceMarks =
    leaveStudentResult?.ref_type_id !== null &&
    leaveStudentResult?.ref_type_id !== undefined;

const groupCanApplyReExam =
    papers.some(
        paper => paper?.exam?.apply_reexam === true
    ) &&
    totals.obtained < totals.min;
                const groupAlreadyApplied = papers.some(item => {
    const sr = getStudentResult(item);

    return sr?.reexam_status === "applied";
});
                const groupInfo = getGroupExamDateInfo(papers);

                const hasReExam = papers?.some(item =>
  (Array?.isArray(item?.studentResult)
    ? item?.studentResult
    : [item?.studentResult]
  ).some(sr => sr?.is_reexam)
);
               

            return (
                <Card
                    className="subject-mobile-card mb-3"
                    key={`mobile-${subjectName}`}
                >
                    <Card.Body>

                        <div className="d-flex justify-content-between align-items-start">
    <div>
        <h6 className="fw-bold mb-1">
            {subjectName} 
            {leaveStudentResult?.ref_type_id && (
                    <sup style={{marginLeft:'5px'}}>
                        <Badge bg="outline-danger">
                        
                        Ref : {
        ExamType?.message?.find(
            exam => exam.id === leaveStudentResult?.ref_type_id
        )?.name
    }
    </Badge>
    </sup>
    )}
        </h6>

        <small className="text-muted">
            {papers.length} Paper
            {papers.length > 1 ? "s" : ""}
        </small><br />
<span style={{float:'left'}}>
        <small className="d-block text-muted">
            Exam Date: {formatDate(groupInfo.latestDate)}
        </small>
       
                {papers.some(item =>
                    (Array.isArray(item.studentResult)
                        ? item.studentResult
                        : [item.studentResult]
                    ).some(sr => sr?.reexam_date)
                ) && (
                    <Button
                        variant="link"
                        className="p-0 mt-1 text-decoration-none fw-semibold"
                        onClick={() => openReExamModal(subjectName)}
                        style={{textAlign:'left', marginBottom:'5px'}}
                    >
                        <FaCalendarAlt className="me-1" />
                        Re-Exam Dates
                    </Button>
                )}

     {hasReExam && (       
                <Button
                variant="link"
        // variant="outline-primary"
        className="p-0 mt-1 text-decoration-none fw-semibold"
        // size="sm"
        onClick={() => openReExamModal1(subjectName)}
        style={{textAlign:'left', marginBottom:'5px'}}
    >
        <FaRedo className="me-1" />
        Re-Exam Marks
    </Button>
    )}
            
        
                
        </span><br />

        <small className="d-block text-muted">
            Time: {firstPaper.start_time} - {firstPaper.end_time}
        </small>
    </div>

    <div className="d-flex align-items-center gap-2">

{showMarks === true && (
        <Button
            variant="primary"
            size="sm"
            onClick={() =>
                handleViewSubjectDetails(
                    subjectName,
                    papers
                )
            }
        >
            <FaEye />
        </Button>
)}
    </div>
</div>

                        <div className="subject-card-stats mt-3">
                            <div className='row'>

                            {showMarks === true && (
                                <>
                                    {!firstPaper?.is_display_grade && (
                                <div className='col-md-4'>
                                    <span className="text-muted small">
                                        Obtained
                                    </span>

                                    <strong
    className={`d-block ${
        totals.obtained >= totals.min
            ? "text-success"
            : "text-danger"
    }`}
>
    {firstPaper?.is_display_grade || (isLeaveSubject && !hasReferenceMarks)
        ? "-"
        : totals.obtained}
</strong>
                                </div>
                                    )}
                                {/* {displayGrade && isLeaveSubject && ( */}
    <div className='col-md-4'>
        <span className="text-muted small">
            Grade
        </span>
        <br />

        <strong>
            <Badge bg={getGradeColor(displayGrade)}>
                {displayGrade}
            </Badge>
        </strong>
    </div>
{/* )} */}
{!firstPaper?.is_display_grade && (
    <div className='col-md-4'>
                                    <span className="text-muted small">
                                        Percentage 
                                    </span> <br />

                                    <strong>
    {firstPaper?.is_display_grade || (isLeaveSubject && !hasReferenceMarks)
        ? "-"
        : `${percentage}%`}
</strong>
                                </div>

)}
    
                                </>
                            )}
                            </div>
                                {!firstPaper?.is_display_grade && (
                            <div className='row'>
                                <div className='col-md-4'>
                                    <div>
                                <span className="text-muted small">
                                    Min
                                </span>
                                <strong className="d-block">
                                        {firstPaper?.is_display_grade || (isLeaveSubject && !hasReferenceMarks) ? "-" : totals.min}
                                </strong>
                            </div>
                                    
                                </div>
                                <div className='col-md-4'>
                                    <div>
                                <span className="text-muted small">
                                    Max
                                </span>
                                <strong className="d-block">
    {firstPaper?.is_display_grade || (isLeaveSubject && !hasReferenceMarks) ? "-" : totals.max}
</strong>
                            </div>
                                    
                                </div>
                                
                                {!firstPaper?.is_display_grade && (
                                    <div className='col-md-4'>
                                    <div>
                                <span className="text-muted small">
                                    Weightage
                                </span>
                                <strong className="d-block">
                                    {firstPaper?.is_display_grade ? "-" : totals.weightage}
                                </strong>
                            </div>
                                    
                                </div>

                                
    )}
                                
                                </div>
                                )}
                                
                        </div>

                        <div className="d-flex justify-content-between align-items-center mt-3">
                            {getAttendanceBadge(firstPaper)}

                            {/* {displayGrade && (
    <Badge
        bg={getGradeColor(displayGrade)}
    >
        {displayGrade}
    </Badge>
)} */}
                        </div>

                        

                        <div className="d-flex flex-column gap-2 mt-3">
                            {renderActionButtons(
                                firstPaper,
                                ctx,
                                papers,
                                subjectName,
                                groupCanApplyReExam,
                                groupAlreadyApplied
                            )}
                        </div>

                    </Card.Body>
                </Card>
            );
        }
    )}
</div>
                        </>
                    ) : (
                        <div className="text-center py-5 empty-state">
                            <FaBook size={48} className="text-muted mb-3 opacity-50" />
                            <h5 className="text-dark mb-2">No Subject Results</h5>
                            <p className="text-muted">No subject results available for this exam.</p>
                        </div>
                    )}
                </Card.Body>
            </Card>
        );
    };

    const renderSkillsTab = () => (
        <Card className="modern-card border-0 shadow-sm">
            <Card.Header className="modern-card-header">
                <h5 className="mb-0">
                    <FaAward className="me-3 text-primary" />
                    Skills Assessment
                </h5>
            </Card.Header>
            <Card.Body>
                {resultData?.skills?.length > 0 ? (
                    <Row>
                        {resultData.skills.map((skill, index) => {
                            const studentResult = Array.isArray(skill.studentResult) ?
                                skill.studentResult[0] : skill.studentResult;

                            return (
                                <Col lg={6} className="mb-3" key={skill.id}>
                                    <Card className="skill-card border-0 h-100">
                                        <Card.Body className="p-3">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <h6 className="fw-bold text-dark mb-1">{skill.skills?.skill_category || 'Unknown Skill'}</h6>
                                                {studentResult?.grade && (
                                                    <Badge bg={getGradeColor(studentResult.grade)} className="skill-grade">
                                                        {studentResult.grade}
                                                    </Badge>
                                                )}
                                            </div>
                                            <div className="skill-details">
                                                <div className="d-flex justify-content-between text-muted small mb-2">
                                                    <span>Status:</span>
                                                    <Badge bg={skill.is_active ? "success" : "secondary"} className="status-badge-sm">
                                                        {skill.is_active ? "Active" : "Inactive"}
                                                    </Badge>
                                                </div>
                                                {studentResult && (
                                                    <div className="skill-performance">
                                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                                            <span className="text-muted small">Marks:</span>
                                                            <strong className="text-dark">
                                                                {studentResult.mark_obtain || '0'}
                                                            </strong>
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                                            <span className="text-muted small">Attendance:</span>
                                                            {/* {getAttendanceBadge(studentResult.is_present)} */}
                                                            {getAttendanceBadge(skill)}
                                                        </div>
                                                        <div className="d-flex justify-content-between align-items-center">
                                                            <span className="text-muted small">Performance:</span>
                                                            <div className="d-flex align-items-center">
                                                                {[1, 2, 3, 4, 5].map((star) => (
                                                                    <FaStar
                                                                        key={star}
                                                                        size={12}
                                                                        className={star <= 3 ? "text-warning" : "text-muted"}
                                                                        style={{ marginRight: '2px' }}
                                                                    />
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                                {!studentResult && (
                                                    <div className="text-center text-muted small py-2">
                                                        No assessment data available
                                                    </div>
                                                )}
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                ) : (
                    <div className="text-center py-5 empty-state">
                        <FaAward size={48} className="text-muted mb-3 opacity-50" />
                        <h5 className="text-dark mb-2">No Skills Assessment</h5>
                        <p className="text-muted">No skills assessment data available for this exam.</p>
                    </div>
                )}
            </Card.Body>
        </Card>
    );

    const renderCurriculumsTab = () => (
        <Card className="modern-card border-0 shadow-sm">
            <Card.Header className="modern-card-header">
                <h5 className="mb-0">
                    <FaTasks className="me-3 text-primary" />
                    Curriculum Activities
                </h5>
            </Card.Header>
            <Card.Body>
                {resultData?.curriculam?.length > 0 ? (
                    <div className="table-responsive">
                        <Table className="mb-0 curriculum-table">
                            <thead className="table-light">
                                <tr>
                                    <th>Activity</th>
                                    <th>Category</th>
                                    <th>Due Date</th>
                                    {showMarks === true && (
                                    <th>Marks</th>
                                    )}
                                    <th>Attendance</th>
                                    {showMarks === true && (
                                    <>
                                    <th>Grade</th>
                                    <th>Status</th>
                                    <th>Remarks</th>
                                    </>
                                    )}
                                </tr>
                            </thead>
                            <tbody>
                                {resultData.curriculam.map((item, index) => {
                                    const studentResult = Array.isArray(item.studentResult) ?
                                        item.studentResult[0] : item.studentResult;

                                    return (
                                        <tr key={item.id} className="curriculum-row">
                                            <td>
                                                <div>
                                                    <h6 className="fw-bold text-dark mb-1">{item.curr_sub?.title || 'Unknown Activity'}</h6>
                                                    <small className="text-muted">Capacity: {item.curr_sub?.capacity || 0}</small>
                                                </div>
                                            </td>
                                            <td>
                                                <Badge bg="info" className="category-badge">
                                                    {item.curr?.name || 'Unknown Category'}
                                                </Badge>
                                            </td>
                                            <td>
                                                <div className="text-dark small">{formatDate(item.curr_sub?.due_date)}</div>
                                            </td>
                                            {showMarks === true && (
                                            <td>
                                                {studentResult?.mark_obtain ? (
                                                    <Badge bg="success" className="marks-badge">
                                                        {studentResult.mark_obtain}
                                                    </Badge>
                                                ) : (
                                                    <span className="text-muted">-</span>
                                                )}
                                            </td>
                                            )}
                                            <td>
                                                {/* {getAttendanceBadge(studentResult?.is_present)} */}
                                                {getAttendanceBadge(item)}
                                            </td>
                                            {showMarks === true && (
                                                <>
                                            <td>
                                                {studentResult?.grade ? (
                                                    <Badge bg={getGradeColor(studentResult.grade)} className="grade-badge">
                                                        {studentResult.grade}
                                                    </Badge>
                                                ) : (
                                                    <span className="text-muted">-</span>
                                                )}
                                            </td>
                                            <td>
                                                <Badge
                                                    bg={item.status === 'Completed' ? 'success' : 'warning'}
                                                    className="status-badge"
                                                >
                                                    {item.status || 'Pending'}
                                                </Badge>
                                            </td>
                                            <td>
                                                <small className="text-muted remarks-text">
                                                    {item.rmk || 'No remarks'}
                                                </small>
                                            </td>
                                            </>
                                            )}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                ) : (
                    <div className="text-center py-5 empty-state">
                        <FaTasks size={48} className="text-muted mb-3 opacity-50" />
                        <h5 className="text-dark mb-2">No Curriculum Activities</h5>
                        <p className="text-muted">No curriculum activities data available for this exam.</p>
                    </div>
                )}
            </Card.Body>
        </Card>
    );

    const renderStudentInfo = () => (
        <Card className="modern-card border-0 shadow-sm mb-4">
            <Card.Header className="modern-card-header">
                <h5 className="mb-0">
                    <FaUser className="me-3 text-primary" />
                    Student Information
                </h5>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col md={6} lg={3}>
                        <div className="student-info-item">
                            <FaIdCard className="text-primary me-2" />
                            <strong>Name:</strong> {resultData.student_full_name}
                        </div>
                    </Col>
                    <Col md={6} lg={3}>
                        <div className="student-info-item">
                            <FaUserGraduate className="text-primary me-2" />
                            <strong>Class:</strong> {resultData.cls_sec?.cls?.Classes} - {resultData.cls_sec?.section?.section}
                        </div>
                    </Col>
                    <Col md={6} lg={3}>
                        <div className="student-info-item">
                            <FaCalendarAlt className="text-primary me-2" />
                            <strong>DOB:</strong> {formatDate(resultData.date_of_birth)}
                        </div>
                    </Col>
                    <Col md={6} lg={3}>
                        <div className="student-info-item">
                            <FaUsers className="text-primary me-2" />
                            <strong>Father:</strong> {resultData.father_full_name || 'N/A'}
                        </div>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    );

    const renderAlert = () => (
        <Alert
            variant={alertVariant}
            show={alertShow}
            onClose={() => setAlertShow(false)}
            dismissible
            className="mt-3"
        >
            <Alert.Heading>
                {alertVariant === 'success' ? 'Success!' : 'Error!'}
            </Alert.Heading>
            {alertMessage}
        </Alert>
    );

    const calculateAttendanceStats = () => {
    if (!resultData?.result) {
        return {
            present: 0,
            absent: 0,
            leave: 0,
            notMarked: 0,
            total: 0,
            percentage: 0
        };
    }

    let present = 0;
    let absent = 0;
    let leave = 0;
    let notMarked = 0;
    let total = 0;

    resultData.result.forEach(item => {
        total++;

        const attendance = item?.attendence;

        if (!attendance?.status) {
            notMarked++;
        } else if (attendance.status === "present") {
            present++;
        } else if (attendance.status === "absent") {
            absent++;
        } else if (attendance.status === "leave") {
            leave++;
        }
    });

    const percentage =
        total > 0 ? (present / total) * 100 : 0;

    return {
        present,
        absent,
        leave,
        notMarked,
        total,
        percentage
    };
};

    if (!examType) {
        return (
            <div className="page-wrapper">
                <div className="content">
                    <Header />
                    <Container className="py-5">
                        <div className="text-center py-5">
                            <FaExclamationTriangle size={64} className="text-warning mb-3" />
                            <h4 className="text-dark mb-3">No Exam Type Selected</h4>
                            <p className="text-muted mb-4">Please select an exam type to view details.</p>
                            <Button variant="primary" onClick={handleBack}>
                                <FaArrowLeft className="me-2" />
                                Go Back to Exams
                            </Button>
                        </div>
                    </Container>
                </div>
            </div>
        );
    }

    const overallPercentage = calculateOverallPercentage();
    const totalSubjects = resultData?.result?.length || 0;
    const passedSubjects = resultData?.result?.filter(item => {
        const studentResult = getStudentResult(item);
        const marksObtained = parseFloat(studentResult?.mark_obtain || 0);
        return marksObtained >= item.min_marks;
    }).length || 0;

    const attendanceStats = calculateAttendanceStats();
    const isAllNotMarked = attendanceStats?.present === 0 && attendanceStats?.absent === 0;

    return (
        <div className="page-wrapper exam-results-wrapper">
            <div className="content">
                <Header />

                <div className="py-4">
                    {/* Alert Section */}
                    {renderAlert()}

                    {/* Header Section */}
                    <div className="page-header-simple mb-4">
                        <div className="header-content">
                            {/* Back Button and Title Row */}
                            {/* Top Action Bar */}
                            <div className="action-bar mb-3">
                                <div className="row g-2 align-items-center">
                                    {/* Back Button - Full width on mobile, auto on larger screens */}
                                    <div className="col-12 col-md-auto">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={handleBack}
                                            className="back-btn w-100 w-md-auto"
                                        >
                                            <div className="d-flex align-items-center justify-content-center justify-content-md-start">
                                                <FaArrowLeft className="me-2 flex-shrink-0" />
                                                <span className="text-nowrap">Back to Exams</span>
                                            </div>
                                        </Button>
                                    </div>

                                    {/* Spacer - Hidden on mobile, visible on larger screens */}
                                    <div className="col-md d-none d-md-block"></div>

                                    {/* Action Buttons - Full width on mobile, auto on larger screens */}
                                    <div className="col-12 col-md-auto">
                                        <div className="d-flex flex-column flex-sm-row gap-2 w-100 w-md-auto">
                                            {/* Print Button */}
                                            

                                            {/* Refresh Button */}
                                            <Button
                                                variant="outline-info"
                                                size="sm"
                                                className="btn-action flex-fill"
                                                onClick={handleRefresh}
                                                disabled={refreshing}
                                            >
                                                <div className="d-flex align-items-center justify-content-center">
                                                    <FaSync
                                                        className={`me-1 me-sm-2 flex-shrink-0 ${refreshing ? 'fa-spin' : ''}`}
                                                        size={14}
                                                    />
                                                    <span className="d-none d-sm-inline">Refresh</span>
                                                </div>
                                            </Button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Main Header */}
                            <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-md-between gap-3">
                                <div className="d-flex align-items-center gap-3">
                                    <div className="header-icon-simple">
                                        <FaGraduationCap size={24} className="text-primary" />
                                    </div>
                                    <div className="flex-grow-1">
                                        <h2
              className="page-title mb-1 w-bold mb-0"
              style={{ letterSpacing: "0.5px" }}>{examType.exam_type_name} - Results</h2>
                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                            <Badge bg="primary" className="exam-type-badge">
                                                <FaUserGraduate className="me-1" size={12} />
                                                {examType.exam_type_title}
                                            </Badge>
                                            <span className="text-muted small">
                                                <FaSchool className="me-1" size={12} />
                                                {className} - {sectionName}
                                            </span>
                                            <span className="text-muted small">
                                                <FaCalendarAlt className="me-1" size={12} />
                                                Session: {session?.Name}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                {resultData && (
                                    <Badge bg="light" className="fs-4 student-badge text-dark">
                                        <FaUser className="me-2" />
                                        {resultData.student_full_name}
                                    </Badge>
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Loading State */}
                    {loading && (
                        <div className="text-center py-5">
                            <div className="loading-spinner">
                                <Spinner animation="border" variant="primary" className="mb-3" />
                                <h5 className="text-dark">Loading Results</h5>
                                <p className="text-muted">Fetching exam results and performance data...</p>
                            </div>
                        </div>
                    )}

                    {/* Results Content */}
                    {!loading && resultData && (
                        <>
                            {/* Student Information */}
                            {renderStudentInfo()}

                            {/* Overall Performance */}
                            <Row className="g-3 mb-4">
                                {/* {showMarks === true && ( */}
                                {showMarks ===true && (
                                <Col xl={3} md={6}>
                                    <StatCard
                                        icon={FaChartLine}
                                        title="Overall Percentage"
                                        value={`${overallPercentage?.toFixed(2)}%`}
                                        subtitle="Total Performance"
                                        color="primary"
                                    />
                                </Col>
                                )}
  {/* <Col xl={3} md={6}>
  <StatCard
    icon={FaUserCheck}
    title="Exam Attendance"
    value={
      isAllNotMarked
        ? "Not Mark"
        : `${attendanceStats.percentage.toFixed(0)}%`
    }
    subtitle={
      isAllNotMarked
        ? "Attendance Not Marked"
        : `${attendanceStats.present}/${attendanceStats.total} Present`
    }
    color="warning"
  />
</Col> */}
                            </Row>

                            {/* Menu Tabs */}
                            {menuData && (
                                <Card className="modern-card border-0 shadow-sm mb-4">
                                    <Card.Header className="modern-card-header">
                                        <Nav variant="pills" className="exam-menu-nav flex-nowrap">
                                            {menuData.map((menuItem) => (
                                                <Nav.Item key={menuItem}>
                                                    <Nav.Link
                                                        eventKey={menuItem}
                                                        active={activeTab === menuItem}
                                                        onClick={() => setActiveTab(menuItem)}
                                                        className="exam-menu-item"
                                                    >
                                                        {menuItem === 'Subjects' && <FaBook className="me-2" />}
                                                        {menuItem === 'Skills' && <FaAward className="me-2" />}
                                                        {menuItem === 'Curriculums' && <FaTasks className="me-2" />}
                                                        {menuItem}
                                                    </Nav.Link>
                                                </Nav.Item>
                                            ))}
                                        </Nav>
                                    </Card.Header>
                                </Card>
                            )}

                            {/* Tab Content */}
                            <div className="tab-content-area">
                                {activeTab === 'Subjects' && renderSubjectsTab()}
                                {activeTab === 'Skills' && renderSkillsTab()}
                                {activeTab === 'Curriculums' && renderCurriculumsTab()}
                            </div>
                        </>
                    )}

                    {/* No Data State */}
                    {!loading && !resultData && (
                        <div className="text-center py-5">
                            <FaExclamationTriangle size={64} className="text-warning mb-3 opacity-50" />
                            <h4 className="text-dark mb-3">No Results Available</h4>
                            <p className="text-muted mb-4">
                                No result data found for {examType.exam_type_name} in {session?.Name} session.
                            </p>
                            <Button variant="primary" onClick={handleRefresh}>
                                <FaSync className="me-2" />
                                Try Again
                            </Button>
                        </div>
                    )}
                </div>

                {/* Chapter Report Modal */}
                {renderChapterModal()}

                {/* Answer Sheet Modal */}
                {renderAnswerSheetModal()}
            </div>

            <Modal
   show={showExamDateModal}
   onHide={() => setShowExamDateModal(false)}
>
   <Modal.Header closeButton>
      <Modal.Title>
         Science Exam Dates
      </Modal.Title>
   </Modal.Header>

   <Modal.Body>
      {selectedDates?.map((date, index) => (
         <div key={index}>
            {formatDate(date)}
         </div>
      ))}
   </Modal.Body>
</Modal>

            <style jsx>{`
.exam-results-wrapper {
    min-height: 100vh;
}

.page-header-simple {
    background: #ffffff;
    border: 1px solid #e9ecef;
    padding: 1.5rem;
    border-radius: 8px;
    margin-bottom: 2rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
}

.back-btn {
    border-radius: 6px;
    font-weight: 500;
}

.header-icon-simple {
    background: #f8f9fa;
    padding: 0.75rem;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #e9ecef;
}

.page-title-simple {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
    color: #212529;
    line-height: 1.2;
}

.exam-type-badge {
    font-size: 0.75rem;
    padding: 0.35rem 0.75rem;
    border-radius: 6px;
}

.student-badge {
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
    border-radius: 6px;
}

.action-buttons {
    flex-shrink: 0;
}

.btn-action {
    border-radius: 6px;
    padding: 0.5rem 1rem;
    font-weight: 500;
    font-size: 0.875rem;
    border: 1px solid;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.btn-action:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.stat-card {
    border-radius: 8px;
    transition: all 0.3s ease;
}

.stat-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
}

.icon-container {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modern-card {
    border-radius: 8px;
    overflow: hidden;
}

.modern-card-header {
    background: #f8f9fa;
    border-bottom: 1px solid #e9ecef;
    padding: 1.25rem 1.5rem;
}

.exam-menu-nav .nav-link {
    border-radius: 6px;
    padding: 0.75rem 1.5rem;
    font-weight: 500;
    color: #6c757d;
    border: 1px solid transparent;
    transition: all 0.3s ease;
}

.exam-menu-nav .nav-link.active {
    background: #007bff;
    color: white;
    border-color: #007bff;
}

.exam-menu-nav .nav-link:hover:not(.active) {
    background: #f8f9fa;
    border-color: #dee2e6;
}

/* Student Info Styles */
.student-info-item {
    display: flex;
    align-items: center;
    padding: 0.5rem 0;
    font-size: 0.9rem;
}

/* Attendance Badge Styles */
.attendance-badge {
    font-size: 0.75rem;
    padding: 0.4rem 0.7rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Results Table Styles */
.results-table .result-row:hover {
    background-color: #f8f9fa;
}

.subject-icon {
    width: 36px;
    height: 36px;
    flex-shrink: 0;
}

.marks-badge {
    font-size: 0.875rem;
    padding: 0.4rem 0.8rem;
}

.marks-obtained-badge {
    font-size: 0.875rem;
    padding: 0.4rem 0.8rem;
}

.percentage-display {
    min-width: 80px;
}

.grade-badge {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
}

.status-badge {
    font-size: 0.75rem;
    padding: 0.35rem 0.7rem;
}

.subject-mobile-list .btn {
    width: 100%;
}

.subject-mobile-card {
    border: 1px solid #e9ecef;
    border-radius: 10px;
    box-shadow: 0 4px 18px rgba(0,0,0,0.05);
}

.subject-card-stats {
    display: flex;
    gap: 1rem;
    background: #f8f9fa;
    border-radius: 8px;
    padding: 0.75rem 1rem;
}

.subject-card-stats div {
    flex: 1;
}

/* View Chapter Report Button Styles */
.view-chapter-btn {
    border-radius: 6px;
    font-size: 0.75rem;
    padding: 0.4rem 0.8rem;
    white-space: nowrap;
    border: 1px solid #0dcaf0;
    transition: all 0.2s ease;
}

.view-chapter-btn:hover:not(:disabled) {
    background-color: #0dcaf0;
    border-color: #0dcaf0;
    transform: translateY(-1px);
}

.view-chapter-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* View Answer Sheet Button Styles */
.view-answer-btn {
    border-radius: 6px;
    font-size: 0.75rem;
    padding: 0.4rem 0.8rem;
    white-space: nowrap;
    border: 1px solid #198754;
    transition: all 0.2s ease;
}

.view-answer-btn:hover:not(:disabled) {
    background-color: #198754;
    border-color: #198754;
    transform: translateY(-1px);
}

.view-answer-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

/* Re-Exam Button Styles */
.reexam-btn {
    border-radius: 6px;
    font-size: 0.75rem;
    padding: 0.4rem 0.8rem;
    white-space: nowrap;
    border: 1px solid #ffc107;
    transition: all 0.2s ease;
}

.reexam-btn:hover:not(:disabled) {
    background-color: #ffc107;
    border-color: #ffc107;
    color: #212529;
    transform: translateY(-1px);
}

.reexam-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.reexam-status-badge {
    font-size: 0.65rem;
    padding: 0.25rem 0.5rem;
}

.already-applied-badge {
    font-size: 0.7rem;
    padding: 0.3rem 0.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Alert Styles */
.alert {
    border-radius: 8px;
    border: none;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

/* Chapter Table Styles */
.chapter-table .chapter-row:hover {
    background-color: #f8f9fa;
}

/* Skills Card Styles */
.skill-card {
    border-left: 4px solid #007bff;
    transition: all 0.3s ease;
}

.skill-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}

.skill-grade {
    font-size: 0.8rem;
    padding: 0.3rem 0.6rem;
}

.status-badge-sm {
    font-size: 0.7rem;
    padding: 0.2rem 0.5rem;
}

/* Curriculum Styles */
.curriculum-table .curriculum-row:hover {
    background-color: #f8f9fa;
}

.category-badge {
    font-size: 0.75rem;
    padding: 0.3rem 0.6rem;
}

.remarks-text {
    max-width: 200px;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.empty-state {
    background: #f8f9fa;
    border-radius: 8px;
}

.loading-spinner {
    max-width: 400px;
    margin: 0 auto;
}

/* Answer Sheet Modal Styles */
.answer-sheet-card {
    border: 1px solid #e9ecef;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0,0,0,0.05);
}

.answer-sheet-frame {
    background: #f8f9fa;
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.75rem;
}

.answer-sheet-frame img {
    // max-height: 100%;
    object-fit: contain;
}

/* Responsive Design */
@media (max-width: 768px) {
    .page-header-simple {
        padding: 1.25rem;
    }

    .page-title-simple {
        font-size: 1.25rem;
    }

    .action-buttons {
        width: 100%;
        justify-content: center;
        margin-top: 1rem;
    }

    .btn-action {
        flex: 1;
        min-width: 0;
        padding: 0.5rem 0.75rem;
    }

    .exam-menu-nav {
        overflow-x: auto;
        flex-wrap: nowrap;
        padding-bottom: 0.5rem;
    }

    .exam-menu-nav .nav-link {
        white-space: nowrap;
        font-size: 0.875rem;
        padding: 0.6rem 1rem;
    }

    .results-table, .curriculum-table, .chapter-table {
        font-size: 0.875rem;
    }

    .subject-icon {
        width: 32px;
        height: 32px;
    }

    .student-info-item {
        font-size: 0.8rem;
    }

    .attendance-badge {
        font-size: 0.7rem;
        padding: 0.3rem 0.5rem;
    }

    .view-chapter-btn, .view-answer-btn, .reexam-btn {
        font-size: 0.7rem;
        padding: 0.3rem 0.6rem;
    }

    .already-applied-badge {
        font-size: 0.65rem;
        padding: 0.25rem 0.5rem;
    }
}

@media (max-width: 576px) {
    .page-header-simple {
        padding: 1rem;
    }

    .page-title-simple {
        font-size: 1.125rem;
    }

    .header-icon-simple {
        padding: 0.5rem;
    }

    .stat-card .icon-container {
        width: 35px;
        height: 35px;
    }

    .stat-card h4 {
        font-size: 1.25rem;
    }

    .exam-menu-nav .nav-link {
        font-size: 0.8rem;
        padding: 0.5rem 0.8rem;
    }

    .view-chapter-btn, .view-answer-btn, .reexam-btn {
        font-size: 0.65rem;
        padding: 0.25rem 0.5rem;
    }
    
    .subject-card-stats {
        flex-direction: column;
    }
    
    .view-chapter-btn .me-1, .view-answer-btn .me-1, .reexam-btn .me-1 {
        margin-right: 0.2rem !important;
    }

    .already-applied-badge {
        font-size: 0.6rem;
        padding: 0.2rem 0.4rem;
    }
    
    .already-applied-badge .me-1 {
        margin-right: 0.2rem !important;
    }
}

@media (max-width: 400px) {
    .exam-type-badge, .student-badge {
        font-size: 0.7rem;
    }

    .marks-badge, .marks-obtained-badge {
        font-size: 0.8rem;
    }

    .grade-badge, .status-badge {
        font-size: 0.7rem;
    }

    .attendance-badge {
        font-size: 0.65rem;
        padding: 0.25rem 0.4rem;
    }

    .view-chapter-btn, .view-answer-btn, .reexam-btn {
        min-width: 80px;
        font-size: 0.6rem;
        padding: 0.2rem 0.4rem;
    }
    
    .view-chapter-btn span, .view-answer-btn span, .reexam-btn span {
        display: none;
    }
    
    .view-chapter-btn .me-1, .view-answer-btn .me-1, .reexam-btn .me-1 {
        margin-right: 0 !important;
    }
}

/* Print Styles */
@media print {
    .action-buttons,
    .btn-action,
    .exam-menu-nav,
    .view-chapter-btn,
    .view-answer-btn,
    .reexam-btn {
        display: none !important;
    }

    .page-header-simple {
        box-shadow: none !important;
        border: 1px solid #000 !important;
    }

    .modern-card {
        box-shadow: none !important;
        border: 1px solid #000 !important;
    }
}
`}</style>
        </div>
    );
};

export default ExamPapers;
